import React, { createContext, useMemo, useState } from "react";
import { AllCitiesModel } from "./types";

interface CitiesInfoContextData {
    citiesInfo: AllCitiesModel[];
    selectedCity: string;
    setAllCitiesContextData: (citiesInfo: AllCitiesModel[]) => void;
    setSelectedCity: (value: string) => void;
}

export const CitiesInfoContext = createContext<CitiesInfoContextData>({
    citiesInfo: [],
    selectedCity: "",
    setAllCitiesContextData: () => { },
    setSelectedCity: () => { }
});

export const AllCitiesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [citiesInfo, setAllCitiesContextData] = useState<AllCitiesModel[]>([]);
    const [selectedCity, setSelectedCity] = useState<string>("");

    const value = useMemo(() => ({ citiesInfo, selectedCity, setAllCitiesContextData, setSelectedCity }), [citiesInfo, selectedCity]);

    return (
        <CitiesInfoContext.Provider value={value}>
            {children}
        </CitiesInfoContext.Provider>
    );
};
